import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "preview-body__effect-pause-message" }

import AudioUploadPrompt from '@/components/preview/AudioUploadPrompt.vue'
import PauseIcon from '@/assets/PauseIcon.svg'
import Spinner from '@/components/common/Spinner.vue'
import { useApplicationStore } from '@/store/application-store'
import { computed, ref, watch } from 'vue'
import useTextStates from '@/composables/UseTextStates'
import { AudioLoadState } from '@/audio/types'


export default /*#__PURE__*/_defineComponent({
  __name: 'PreviewBody',
  props: {
    showPrompt: { type: Boolean },
    isDragged: { type: Boolean },
    loadState: null,
    fileName: null
  },
  emits: ["fileSelected"],
  setup(__props: any, { emit: emits }: { emit: ({
  (event: 'fileSelected', file: File | string, fileName?: string): void,
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  showPrompt: boolean
  isDragged: boolean
  loadState: AudioLoadState
  fileName: string
};

let showEffectPauseMessage  = ref(false)
let effectPauseMessageTimeoutId: ReturnType<typeof setTimeout>
const applicationStore = useApplicationStore()

const { saveText } = useTextStates()



const isLoading = computed(() => !props.showPrompt && (applicationStore.isBackgroundLoading || applicationStore.isStickerLoading))



// This ref is required to only show the exit animation when dragging has ended. This is only possible to do if we
// activate the animation after the _first_ time that dragging ends - otherwise we end up with the animation on mount
const dragLeave = ref(false)

watch(() => props.isDragged, () => {
  dragLeave.value = !props.isDragged
})

const onCanvasDeselect = (event: Event) => {
  // Make sure the area clicked is the preview body itself and not it's children
  if (event.target === event.currentTarget) {
    // deselect the canvas selected entities
    if ( !props.showPrompt && applicationStore.editTextState === 'none') {
      applicationStore.deselectAllEntities()
    }
    
    // Save text on navigating away from editing mode
    if ( applicationStore.editTextState !== 'none' && applicationStore.currentEditingText && applicationStore.currentEditingText.text.trim() !== '') {
      saveText(applicationStore.currentEditingText)
    }
  }
}

const onFileSelected = (file: File | string, fileName?: string) => {
  emits('fileSelected', file, fileName)
}

watch(() => applicationStore.disableEffectsOnPreview, () => {
  if (applicationStore.selectedText !== null && applicationStore.editTextState !== 'none') {
    return
  }
  clearTimeout(effectPauseMessageTimeoutId)
  showEffectPauseMessage.value = applicationStore.disableEffectsOnPreview
  if (showEffectPauseMessage.value) {
    effectPauseMessageTimeoutId = setTimeout(() => showEffectPauseMessage.value = false, 1300)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "preview-body",
    onPointerdown: onCanvasDeselect,
    onContextmenu: _cache[0] || (_cache[0] = ($event: any) => ($event.preventDefault()))
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(['preview-body__canvas-area', 
      {
        'preview-body__canvas-area--drag-over': __props.isDragged, 
        'preview-body__canvas-area--drag-leave': dragLeave.value
      }])
    }, [
      _renderSlot(_ctx.$slots, "canvas"),
      _createVNode(_Transition, { name: "preview-body__fade-transition" }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", _hoisted_1, [
            _createVNode(_unref(PauseIcon)),
            _createTextVNode(" effects paused ")
          ], 512), [
            [_vShow, _unref(showEffectPauseMessage)]
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(AudioUploadPrompt, {
        class: "preview-body__audio-upload-prompt",
        "is-dragged": __props.isDragged,
        "load-state": __props.loadState,
        "file-name": __props.fileName,
        onFileSelected: onFileSelected
      }, null, 8, ["is-dragged", "load-state", "file-name"]), [
        [_vShow, __props.showPrompt]
      ]),
      _withDirectives(_createVNode(Spinner, { class: "preview-body__loading-spinner" }, null, 512), [
        [_vShow, _unref(isLoading)]
      ])
    ], 2)
  ], 32))
}
}

})